import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "./ValidationMessage";

const CheckBoxWithChild = (props) => {
	const hasError = !!props.error;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.error ? <ValidationMessage message={props.error} /> : null;
	const optionList = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const horizontal = !!props.horizontal;
	const tooltip = props.tooltip ? props.tooltip : "";
	const disabled = !!props.disabled;
	const locked = !!props.locked;
	const optional = !!props.optional;

	let value = "null";
	if (props.value != null) {
		if (props.value == false || props.value == "false") {
			value = false;
		} else if (props.value == true || props.value == "true") {
			value = true;
		}
	}

	const child = props.child && (props.value === "true" || props.value == true) ?
		props.child : null;

	return (
		<div className={"u-clear"}>
			<div key={props.name} className="c-input__group" style={{ marginBottom: "0px" }}>
				<input type="checkbox" name={props.name} onChange={props.onChange} value={props.value}
					checked={value} id={props.name} disabled={disabled} />
				<label htmlFor={props.name}>{props.label}</label>
			</div>
			{child}
			{validation}
		</div>
	);
};

CheckBoxWithChild.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	onChange: PropTypes.func.isRequired,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	horizontal: PropTypes.bool,
	labelInside: PropTypes.bool,
	size: PropTypes.number,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	optional: PropTypes.bool,
	child: PropTypes.element
};

export default CheckBoxWithChild;
